import React, { useMemo } from "react";
import { MadFragment } from "../../graphql/fragments";
import useTranslations from "../../hooks/useTranslations";
import { ContractPlate } from "../utils/ContractPlate";

type FollowUpContractsProps = {
  mad: MadFragment;
};

const FollowUpContracts: React.FC<FollowUpContractsProps> = ({ mad }) => {
  const t = useTranslations();

  const contractsByContractTemplateId = useMemo(() => (
    mad.template.contractTemplates.reduce((contractsByContractTemplateId, contractTemplate) => {
      contractsByContractTemplateId[contractTemplate.id] = mad.contracts.find((contract) => contract.contractTemplate.id === contractTemplate.id);

      return (contractsByContractTemplateId);
    }, {})
  ), [mad.template]);

  return (
    <div>
      {mad.template.contractTemplates.map((contractTemplate) => (
        <ContractPlate
          key={contractTemplate.id}
          contractTemplate={contractTemplate}
          madId={mad.id}
          contract={contractsByContractTemplateId[contractTemplate.id]}
        />
      ))}
    </div>
  );
};

export default FollowUpContracts;
